import { Component, inject, Input, ViewChild } from '@angular/core';
import { Property } from '@modules/universal-billing/properties/properties.interface';
import {
  PropertyPovidersComponent
} from '@modules/settings/properties/property-configurations/property-poviders/property-poviders.component';
import {
  ConfigurationFormComponent
} from '@modules/settings/properties/property-configurations/configuration-form/configuration-form.component';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { ModalService } from '@shared/services/modal/modal.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader, NgbAccordionItem,
  NgbDropdownItem
} from '@ng-bootstrap/ng-bootstrap';
import { NgCanDirective } from '@common/rbac/ng-can.directive';

@Component({
  selector: 'app-configuration-providers',
  standalone: true,
  imports: [
    PropertyPovidersComponent,
    TranslatePipe,
    NgbAccordionDirective,
    NgbDropdownItem,
    NgbAccordionCollapse,
    NgbAccordionHeader,
    NgbAccordionItem,
    NgbAccordionButton,
    NgCanDirective
  ],
  templateUrl: './configuration-providers.component.html',
  styleUrl: './configuration-providers.component.scss'
})
export class ConfigurationProvidersComponent {
  @Input() property: Property;
  @ViewChild('propertyProviders') propertyProviders: PropertyPovidersComponent;
  modalService = inject(ModalService);
  translateService = inject(TranslateService);
  onAdd() {
    this.modalService.open({
      component: ConfigurationFormComponent,
      title: this.translateService.instant('PROPERTY.ADD_PROPERTY'),
      componentOptions: {
        buildingId: this.property.id,
      },
      modalOptions: {
        size: 'lg',
      }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.propertyProviders.loadData();
      }
    })
  }
}
